import GalleryItemDto from './GalleryItemDto';

export default class GalleryItems
{
    protected items: Array<GalleryItemDto> = [];

    public push(item: GalleryItemDto)
    {
        this.items.push(item);
    }

    public getIdx(url: string): number
    {
        return this.items.findIndex((item) => item.url === url);
    }

    public isExist(url: string): boolean
    {
        return this.getIdx(url) !== -1;
    }

    public export(): Array<GalleryItemDto>
    {
        return this.items;
    }
}
